<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Client Callbacks' }}</h2>
      <p>Result webhooks we call on a client's URL when an event fires (e.g. payment.success), with their delivery log.</p>
    </div>
  </div>

  <app-client-callbacks />
</div>
